import { createContext } from 'react'

const BedbankCardInclusionsContext = createContext(false)

export default BedbankCardInclusionsContext
